export default __webpack_public_path__ + "b627d1a45acbb0d58ccb161ab2b22958.png";